/**
 * Animation Module
 *
 * This module handles animations on the homepage
 */

import jQuery from 'jquery';
import { gsap, TimelineMax, Power2 } from 'gsap';
import ScrollMagic from 'scrollmagic';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const Animation = {
  setupAnimations: function (homeController, isMobile) {
    if (isMobile) {
      return; // Skip animations on mobile
    }

    // Home intro animation
    const $introSubtitle = jQuery('.home-intro__wrapper .subtitle');
    const $introTitle = jQuery('.home-intro__wrapper .title');
    const $introParagraph = jQuery('.home-intro__wrapper .paragraph');
    const $introShopLink = jQuery('.home-intro__wrapper .shop-link');
    const $introContainer = jQuery('.video__wrapper .intro-container');

    if ($introContainer.length) {
      let homeIntroTl = new TimelineMax({ paused: true });

      if ($introSubtitle.length) {
        homeIntroTl.fromTo(
          $introSubtitle,
          0.5,
          { y: 8, autoAlpha: 0, ease: Power2.easeIn },
          { y: 0, autoAlpha: 1, ease: Power2.easeIn },
          0
        );
      }

      if ($introTitle.length) {
        homeIntroTl.fromTo(
          $introTitle,
          0.5,
          { y: 8, autoAlpha: 0, ease: Power2.easeIn },
          { y: 0, autoAlpha: 1, ease: Power2.easeIn },
          '-=.25'
        );
      }

      if ($introParagraph.length) {
        homeIntroTl.fromTo(
          $introParagraph,
          0.5,
          { y: 8, autoAlpha: 0, ease: Power2.easeIn },
          { y: 0, autoAlpha: 1, ease: Power2.easeIn },
          '-=.25'
        );
      }

      if ($introShopLink.length) {
        homeIntroTl.fromTo(
          $introShopLink,
          0.5,
          { y: 8, autoAlpha: 0, ease: Power2.easeIn },
          { y: 0, autoAlpha: 1, ease: Power2.easeIn },
          '-=.25'
        );
      }

      var homeIntro = new ScrollMagic.Scene({
        triggerElement: '.video__wrapper .intro-container',
        reverse: true,
        triggerHook: 0.5,
        offset: 0,
      })
        .on('enter', function (e) {
          homeIntroTl.play();
        })
        .on('leave', function (e) {
          // homeIntroTl.reverse();
        })
        .addTo(homeController);
    }

    // Home slider animation
    const $sliderContent = jQuery('.home-slider__wrapper .home-slider-content');
    const $sliderPosition = jQuery('.home-slider__wrapper .home-slider__position');
    const $sliderController = jQuery('.home-slider__wrapper .home-slider-controller');
    const $shopLinkTrigger = jQuery('.home-intro__wrapper .shop-link');

    if ($sliderContent.length || $sliderPosition.length || $sliderController.length) {
      let homeSliderTl = new TimelineMax({ paused: true });

      if ($sliderContent.length) {
        homeSliderTl.fromTo(
          $sliderContent,
          0.8,
          { x: -18, ease: Power2.easeIn },
          { x: 0, ease: Power2.easeInOut },
          0
        );
      }

      if ($sliderPosition.length) {
        homeSliderTl.fromTo(
          $sliderPosition,
          0.8,
          { x: 18, ease: Power2.easeIn },
          { x: 0, ease: Power2.easeInOut },
          0
        );
      }

      if ($sliderController.length) {
        homeSliderTl.fromTo(
          $sliderController,
          0.8,
          { y: 20, autoAlpha: 0, ease: Power2.easeIn },
          { y: 0, autoAlpha: 1, ease: Power2.easeInOut }
        );
      }

      if ($shopLinkTrigger.length) {
        var homeSlider = new ScrollMagic.Scene({
          triggerElement: '.home-intro__wrapper .shop-link',
          reverse: true,
          triggerHook: 0.5,
          offset: 0,
        })
          .on('enter', function (e) {
            homeSliderTl.play();
          })
          .on('leave', function (e) {
            // homeSliderTl.reverse();
          })
          .addTo(homeController);
      }
    }

    // Home quote animation
    const $historyWrapper = jQuery('.home-history__wrapper');
    const $historyTextContent = jQuery('.home-history__wrapper .text-content');
    const $historyQuote = jQuery('.home-history__wrapper .quote');
    const $historyLink = jQuery('.home-history__wrapper .text-content .history-link');
    const $historyImageCaption = jQuery('.home-history__wrapper .image-caption');

    if ($historyWrapper.length) {
      let homeQuoteTl = new TimelineMax({ paused: true });

      if ($historyTextContent.length) {
        homeQuoteTl.fromTo(
          $historyTextContent,
          1,
          { y: 8, autoAlpha: 0, ease: Power2.easeIn },
          { y: 0, autoAlpha: 1, ease: Power2.easeIn },
          0
        );
      }

      if ($historyQuote.length) {
        homeQuoteTl.fromTo(
          $historyQuote,
          0.8,
          { y: 8, autoAlpha: 0, ease: Power2.easeIn },
          { y: 0, autoAlpha: 1, ease: Power2.easeIn },
          '-=.8'
        );
      }

      if ($historyLink.length) {
        homeQuoteTl.fromTo(
          $historyLink,
          0.5,
          { y: 8, autoAlpha: 0, ease: Power2.easeIn },
          { y: 0, autoAlpha: 1, ease: Power2.easeIn },
          '-=.25'
        );
      }

      if ($historyImageCaption.length) {
        homeQuoteTl.fromTo(
          $historyImageCaption,
          0.8,
          { y: 8, autoAlpha: 0, ease: Power2.easeIn },
          { y: 0, autoAlpha: 1, ease: Power2.easeIn },
          '-=.25'
        );
      }

      var homeQuote = new ScrollMagic.Scene({
        triggerElement: '.home-history__wrapper',
        reverse: true,
        triggerHook: 0.5,
        offset: 0,
      })
        .on('enter', function (e) {
          homeQuoteTl.play();
        })
        .on('leave', function (e) {
          // homeQuoteTl.reverse();
        })
        .addTo(homeController);
    }

    // Vines Parallax animation with GSAP ScrollTrigger
    this.setupParallaxEffect();

    // Lazy Susan animation
    const $lazySusanTitle = jQuery('.home-lazy-susan__wrapper .title');
    const $vinesParallaxBlackFade = jQuery('.home-vines-parallax__wrapper .black-fade-el');

    if ($lazySusanTitle.length && $vinesParallaxBlackFade.length) {
      let homelazySusanTl = new TimelineMax({ paused: true });

      homelazySusanTl.fromTo(
        $lazySusanTitle,
        1.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        0
      );

      var homelazySusan = new ScrollMagic.Scene({
        triggerElement: '.home-vines-parallax__wrapper .black-fade-el',
        reverse: true,
        triggerHook: 0.5,
        offset: 0,
      })
        .on('enter', function (e) {
          homelazySusanTl.play();
        })
        .on('leave', function (e) {
          // homelazySusanTl.reverse();
        })
        .addTo(homeController);
    }
  },

  setupParallaxEffect: function () {
    // Target elements
    const $bushBackground = jQuery('#bush-background');
    const $bushForeground = jQuery('#bush-foreground');
    const $vinesWrapper = jQuery('.home-vines-parallax__wrapper');

    // Only proceed if the wrapper element exists
    if (!$vinesWrapper.length) {
      return;
    }

    // Background parallax effect
    if ($bushBackground.length) {
      gsap.to('#bush-background', {
        scrollTrigger: {
          trigger: '.home-vines-parallax__wrapper',
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
        y: 150,
        ease: 'none',
      });
    }

    // Foreground parallax effect with scaling
    if ($bushForeground.length) {
      gsap.to('#bush-foreground', {
        scrollTrigger: {
          trigger: '.home-vines-parallax__wrapper',
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
        y: 50,
        scale: 1.3,
        ease: 'none',
      });
    }
  },

  init: function (homeController, isMobile) {
    this.setupAnimations(homeController, isMobile);
  },
};

export default Animation;
